﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customFormSetting from './tpl/customFormSetting.html';

import View_FormSetting from './formSetting';

import language from '../../../common/language';
import View_Information from '../../../lib/views/information/information';
import * as Entities_Empty from '../../../lib/entities/empty';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_Memory from '../../entities/memory';

import config from '../../../common/config';
import Help from '../../helper/help';
import View_Render from '../render/render';

import View_CustomHeader from '../region/customHeader/customHeader';




export default View_LayoutError.extend({
    designRegion: '#designRegion_modal',
    getTemplate: function () {
        if (this.options.designMode) {
            return tpl_customFormSettingDesign({ model: this.model.toJSON() });
        } else {
            return tpl_customFormSetting({ model: this.model.toJSON() });
        }
    },
    regions: {
        information: "#customFormSettingInformation",
        customHeader: "#customHeader"
    },
    onBeforeShow: function () {
        this.information.show(new View_Information({ collection: this.informationCollection, app: this.app }));

        var customHeaderModel = new Entities_Empty.Model();

        if (this.model) {
            customHeaderModel.attributes.Name = this.model.attributes.Name;
        } else {
            customHeaderModel.attributes.Name = "";
        }

        customHeaderModel.attributes.Title = resources.X101261;
        customHeaderModel.attributes.ShowSave = true;
        customHeaderModel.attributes.ShowBack = true;

        this.customHeader.show(new View_CustomHeader({ app: this.app, model: customHeaderModel }));
    },
    initialize: function () {
        var self = this;

        this.app = this.options.app;

        this.informationCollection = new Entities_Empty.Collection();

        this.listenTo(this.collection, 'add', this.updateInformationCollection, this);
        this.listenTo(this.collection, 'remove', this.updateInformationCollection, this);

        this.localSetting = new Entities_Empty.Model();
        this.localSetting.attributes.EventId = -1;

        this.setHasChanged(false);
        this.oldModel = this.model.clone();

        var userChannel = Backbone.Radio.channel('app');
        this.listenTo(userChannel, 'customHeader:iconSave', function () {
            self.btnSubmitClick(null);
        });
        this.listenTo(userChannel, 'customHeader:iconBack', function () {
            self.customFormSetting_btnBack_click();
        });
    },
    signalR_init: function () {
        //this.IWannaChat = $.connection.Events4usHub;
        //$.connection.hub.start();
    },
    help: function () {
        Help.help(this, true, 'customSchemaLive');
    },
    setHasChanged: function (enable) {
        this.hasChanged = enable;
    },
    getHasChanged: function () {
        return this.hasChanged;
    },
    saveHasChanged: function (callback) {
        this.save(callback);
    },
    cancelHasChanged: function () {
        this.model.attributes = this.oldModel.attributes;
    },
    modelHasChanged: function () {
        var changes = false;

        this.setModel();

        if (this.model) {
            if ((this.model.attributes.FormMenuName != this.oldModel.attributes.FormMenuName) ||
                (this.model.attributes.FormSubmitBtnName != this.oldModel.attributes.FormSubmitBtnName) ||
                (this.model.attributes.FormCancelBtnName != this.oldModel.attributes.FormCancelBtnName) ||
                (this.model.attributes.FormSubmitBtnSucces != this.oldModel.attributes.FormSubmitBtnSucces) ||
                (this.model.attributes.FormNotifyEmail != this.oldModel.attributes.FormNotifyEmail) ||
                (this.model.attributes.FormNotifyEmailAddress != this.oldModel.attributes.FormNotifyEmailAddress)) {
                changes = true;
            }
        }

        this.setHasChanged(changes);
    },
    ui: {
        'customFormSettingInformation': '#customFormSettingInformation',
        'customFormSetting_div_anySchema': '#customFormSetting_div_anySchema',
        'customFormSetting_inputNameGroup': '#customFormSetting_inputNameGroup',
        'customFormSetting_selectEvent': '#customFormSetting_selectEvent',
        'customFormSetting_divSchemaMenuName': '#customFormSetting_divSchemaMenuName',

        'customFormSetting_inputFormMenuName': '#customFormSetting_inputFormMenuName',
        'customFormSetting_inputFormSubmitBtnName': '#customFormSetting_inputFormSubmitBtnName',
        'customFormSetting_inputFormCancelBtnName': '#customFormSetting_inputFormCancelBtnName',
        'customFormSetting_inputFormSubmitBtnSucces': '#customFormSetting_inputFormSubmitBtnSucces',
        'customFormSetting_selectFormNotifyEmail': '#customFormSetting_selectFormNotifyEmail',
        'customFormSetting_inputFormNotifyEmailAddress': '#customFormSetting_inputFormNotifyEmailAddress',
        'help': '#help',
        'designRegion_body': '#designRegion_body',
        'designRegion_btnOk': '#designRegion_btnOk',
        'customFormSetting_inputNameGroup': '#customFormSetting_inputNameGroup',
        'customFormSetting_btnSubmit': '#customFormSetting_btnSubmit',
        'customFormSetting_btnBack': '#customFormSetting_btnBack',
        'customFormSetting_btnDisplay': '#customFormSetting_btnDisplay'
    },
    events: {
        'click @ui.customFormSetting_btnSubmit': 'btnSubmitClick',
        'click #help': 'help',
        'click @ui.designRegion_btnOk': 'designRegion_btnOk',
        'click @ui.customFormSetting_btnBack	': 'customFormSetting_btnBack_click',
        'click @ui.customFormSetting_btnDisplay': 'customFormSetting_btnDisplay_click'
    },
    onRender: function () {
        this.setupEvent();
        this.renderInformation();

        if (this.app.mode == 1) {
            this.ui.customFormSetting_btnSubmit.css('display', 'none');
            this.ui.customFormSetting_btnBack.css('display', 'none');
        }

        var selected0 = '';
        var selected1 = '';
        var options = '';
        if (this.model.attributes.FormNotifyEmail == 0) selected0 = 'selected = "selected"';
        if (this.model.attributes.FormNotifyEmail == 1) selected1 = 'selected = "selected"';
        options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100466, "0", selected0);
        this.ui.customFormSetting_selectFormNotifyEmail.append(options);
        options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100467, "1", selected1);
        this.ui.customFormSetting_selectFormNotifyEmail.append(options);

        return this;
    },
    renderInformation: function () {
        this.informationCollection.reset();

        this.app.renderInformation({ informationCollection: this.informationCollection });
    },
    updateInformationCollection: function () {
        this.renderInformation();
        this.informationCollection.trigger('change');
    },
    customViewEvent_setActive: function () {
        var array = [];

        if (this.localSetting.attributes.EventId != -1) {
            var tmp = { "id": this.localSetting.attributes.EventId };
            array.push(tmp);
        }

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('customViewEvent:setActive', array);
    },
    onAttach() {
        this.customViewEvent_setActive();

        if (this.options.designMode) {
            var height = $(window).height() * 0.8;
            this.ui.designRegion_body.height(height);
        }
    },
    setupEvent: function () {
    },
    setModel: function () {
        this.model.set({
            FormMenuName: this.ui.customFormSetting_inputFormMenuName.val(),
            FormSubmitBtnName: this.ui.customFormSetting_inputFormSubmitBtnName.val(),
            FormCancelBtnName: this.ui.customFormSetting_inputFormCancelBtnName.val(),
            FormSubmitBtnSucces: this.ui.customFormSetting_inputFormSubmitBtnSucces.val(),
            FormNotifyEmail: parseInt(this.ui.customFormSetting_selectFormNotifyEmail.val()),
            FormNotifyEmailAddress: this.ui.customFormSetting_inputFormNotifyEmailAddress.val(),
        }, { silent: true });
    },
    save: function (callbackRouter) {
        var self = this;

        var dialogWaitingModel = new Entities_Empty.Model();
        dialogWaitingModel.attributes.Title = resources.X100408;
        dialogWaitingModel.attributes.Text = resources.X100409;
        dialogWaitingModel.attributes.Button = resources.X100279;

        var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: this });
        var callback = function (options) {
            self.stopListening(dialogWaiting, "dialog:okclicked", callback);
        }
        this.listenTo(dialogWaiting, "dialog:okclicked", callback);
        this.app.dialogRegion.show(dialogWaiting);

        this.setModel();

        var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.eventId, ModuleType: 100 })[0];
        var data = JSON.parse(customModule.attributes.Data);
        var customModule_data = new Entities_Memory.Model(data[0].Data);

        customModule_data.attributes.Form = this.model.toJSON();
        var strJson = JSON.stringify(customModule_data.toJSON());
        customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

        customModule.save(customModule.attribute, {
            silent: false,
            wait: true,
            success: function () {
                dialogWaiting.triggerMethod('dialog:close');

                var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: self.options.eventId });
                if (customEvent && customEvent.length > 0) {
                    var render = new View_Render({ collection: customEvent, app: self.app });
                    //var message = 'EVENT_REFRESH';
                    //render.pushMessage(self.options.eventId, message);
                    //callbackRouter();
                    render.doIt(callbackRouter, true, 'EVENT_REFRESH', false);
                }
            }
        });


        //this.model.save(this.model.attributes, {
        //    silent: true,
        //    wait: true,
        //    success: function () {
        //        dialogWaiting.triggerMethod('dialog:close');
        //        self.oldModel = self.model.clone();

        //        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ FormModel: self.model.attributes.id })
        //        var render = new View_Render({ collection: customEvent, app: self.app });
        //        self.app.renderRegion.show(render);
        //        var renderFinishCallback = function (options) {
        //            if (callbackRouter) {
        //                callbackRouter();
        //            }
        //        }
        //        render.doIt(renderFinishCallback, false, 'EVENT_REFRESH', false);
        //    }
        //});
    },
    btnSubmitClick: function (event) {
        if (event) {
            event.preventDefault();
        }

        var self = this;

        this.setModel(this.model);
        this.oldModel = this.model.clone();

        /*this.model.validateNoBackbone(app, false, function (ret) {
            var modelErrors = ret;
            if (modelErrors) {
                self.hideErrors();
                self.showErrors(self.model.errors);
            }
            else {
                self.hideErrors();*/

        var dialogWaitingModel = new Entities_Empty.Model();
        dialogWaitingModel.attributes.Title = resources.X100408;
        dialogWaitingModel.attributes.Text = resources.X100181;
        dialogWaitingModel.attributes.Button = resources.X100279;

        var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });
        var callback = function (options) {
            self.stopListening(dialogWaiting, "dialog:okclicked", callback);
        }
        self.listenTo(dialogWaiting, "dialog:okclicked", callback);
        self.app.dialogRegion.show(dialogWaiting);

        var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.eventId, ModuleType: 100 })[0];
        var data = JSON.parse(customModule.attributes.Data);
        var customModule_data = new Entities_Memory.Model(data[0].Data);

        customModule_data.attributes.Form = this.model.toJSON();
        var strJson = JSON.stringify(customModule_data.toJSON());
        customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

        customModule.save(customModule.attribute, {
            silent: false,
            wait: true,
            success: function () {
                dialogWaiting.triggerMethod('dialog:close');

                var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: self.options.eventId });
                if (customEvent && customEvent.length > 0) {
                    var render = new View_Render({ collection: customEvent, app: self.app });
                    //var message = 'EVENT_REFRESH';
                    //render.pushMessage(self.options.eventId, message);
                    var callbackRouter = function (options) {
                    }
                    render.doIt(callbackRouter, true, 'EVENT_REFRESH', false);
                }
            }
        });


        /*self.model.save(self.model.attributes, {
            silent: true,
            wait: true,
            success: function () {
                dialogWaiting.triggerMethod('dialog:close');
                self.oldModel = self.model.clone();

                var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ FormModel: self.model.attributes.id })
                var render = new View_Render({ collection: customEvent, app: self.app });
                self.app.renderRegion.show(render);
                var renderFinishCallback = function (options) {
                }
                render.doIt(renderFinishCallback, false, 'EVENT_REFRESH', false);
            }
        });*/
        // }
        //});
    },
    designRegion_btnOk() {
        this.triggerMethod('dialog:close');

    },
    customFormSetting_btnBack_click: function (event) {
        this.app.router.navigate("#customEventEditItem?id=" + this.options.eventId);
        this.app.router.customEventEditItem(this.options.eventId, this.options.scroll, 4, false, false);
    },
    customFormSetting_btnDisplay_click: function (event) {
        var self = this;

        /*var tmpSelectedModelSetting = self.app.entities.collections.customModule.where({ EventId: this.model.id, ModuleType: 98 })[0];
        var data = JSON.parse(tmpSelectedModelSetting.attributes.Data);
        var themeCollection = new Entities_Memory_Position.Collection(data[0].Data.ThemeCollection);
        var selectedModel = data[0].Data.ThemeCollectionSelected;
        var themeCollectionModel = themeCollection.where({ id: selectedModel })[0];*/


        var customModule = self.app.entities.collections.customModule.where({ EventId: this.options.eventId, ModuleType: 100 })[0];
        var data = JSON.parse(customModule.attributes.Data);
        var customModule_data = new Entities_Memory.Model(data[0].Data);

        //var modelGenerelSetting = new Entities_Memory.Model(data[0].Data.SchemaScreen);

        var tmpModel = new Entities_Empty.Model(data[0].Data.Form);

        var formSetting = new View_FormSetting({ app: this.app, model: tmpModel, parent: self, fontSelect: 1, themeCollectionModel: customModule_data });


        var callback01 = function (options) {
            self.stopListening(formSetting, "dialog:btn01clicked", callback01);
            self.stopListening(formSetting, "dialog:btn02clicked", callback02);

            customModule_data.attributes.Form = formSetting.model.toJSON();
            var strJson = JSON.stringify(customModule_data.toJSON());
            //var strJson = JSON.stringify(formSetting.model.toJSON());
            customModule.attributes.Data = '[{ "Data" : ' + strJson + '}]';

            this.model = formSetting.model;

            customModule.save(customModule.attribute, {
                silent: false,
                wait: true,
                success: function () {
                    var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: self.options.eventId });
                    if (customEvent && customEvent.length > 0) {
                        var render = new View_Render({ collection: customEvent, app: self.app });
                        var message = 'EVENT_REFRESH';
                        render.pushMessage(self.model.id, message);
                    }
                }
            });
        }
        self.listenTo(formSetting, "dialog:btn01clicked", callback01);

        var callback02 = function (options) {
            self.stopListening(formSetting, "dialog:btn01clicked", callback01);
            self.stopListening(formSetting, "dialog:btn02clicked", callback02);
        }
        self.listenTo(formSetting, "dialog:btn02clicked", callback02);

        self.app.dialogRegion.show(formSetting);
    }
}, Backbone.Radio.Requests);
